import React from 'react'
import DataPolicyDE from './dataPolicies/DataPolicyDE'
import DataPolicyEN from './dataPolicies/DataPolicyEN'
import useLanguage from '@hooks/useLanguage.hook'

const DataProtection = () => {
    const [lng] = useLanguage()

    return <div>{lng.includes('en') ? <DataPolicyEN /> : <DataPolicyDE />}</div>
}

export default DataProtection
